<template>
    <TheContentHeader titlePage="Perfil de usuario" />
    <the-content-body>
        <widget-loading v-if="isLoadingUser" />
        <template v-else>
            <div class="row">
                <!-- Foto de Perfil -->
                <div class="col-lg-4">
                    <!-- Perfil -->
                    <div class="card">
                        <div class="card-body text-center">
                            <the-user-avatar :name="userProfile.name" avatarSize="xl"></the-user-avatar>
                            <!-- <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
                                alt="avatar" class="rounded-circle img-fluid" style="width: 150px;"> -->
                            <h5 class="my-2">{{ userProfile.alias }}</h5>
                            <p class="text-muted mb-4">{{ userProfile.perfilDescripcion }}</p>
                            <!-- <p class="text-muted mb-4">Bay Area, San Francisco, CA</p> -->
                            <div class="d-flex justify-content-center mb-2">
                                <button type="button" data-mdb-button-init data-mdb-ripple-init
                                    class="btn btn-primary">Follow</button>
                                <button type="button" data-mdb-button-init data-mdb-ripple-init
                                    class="btn btn-outline-primary ms-1">Message</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Datos del usuario -->
                <div class=col-lg-8>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Nombre y Apellido</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.name }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Usuario</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.username }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Email</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.email }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Celular</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.celular }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Tipo Documento</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.nombreTipoDoc }}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">No. Documento</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{ userProfile.numeroDoc }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Botonoes de navegación -->
            <div class="d-flex justify-content-evenly mt-2  mb-2 bg-light rounded">
                <base-button-forms :classButton="tap === 1 ? 'btn-primary m-2' : 'btn-outline-primary m-2'"
                    label="Información" type="button" icon="fa-solid fa-circle-info" :onClick="() => tap = 1"
                    :permissionId="0"></base-button-forms>
                <base-button-forms :classButton="tap === 2 ? 'btn-primary m-2' : 'btn-outline-primary m-2'"
                    label="Seguridad" type="button" icon="fa-solid fa-file" :onClick="() => tap = 2"
                    :permissionId="0"></base-button-forms>
                <base-button-forms :classButton="tap === 3 ? 'btn-primary m-2' : 'btn-outline-primary m-2'"
                    label="Configuración" type="button" icon="fa-solid fa-users" :onClick="() => tap = 3"
                    :permissionId="0"></base-button-forms>
            </div>
            <transition name="fade">
                <!-- Datos usuario almacen -->
                <div>
                    <div v-if="tap == 1">
                        <div class="row">
                            <!-- Datos Aliado -->
                            <div class="col-lg-4">
                                <div class="card mb-4 mb-md-0">
                                    <div class="card-body">
                                        <p class="mb-4 fw-bold">Información Aliado</p>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">Nombre</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.nombreAliado }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">Tipo Doc</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.NombreTipoIdAliado }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">No. Doc</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.NumIdentificacionAliado }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Datos Almacén Activo -->
                            <div class="col-lg-8 mb-4">
                                <div class="card mb-4 mb-md-0">
                                    <div class="card-body">
                                        <p class="mb-4 fw-bold">Información Almacén activo</p>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">Nombre</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.nombreAlmacen }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">Dirección</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.direccionAlmacen }}</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <p class="mb-0">Rol</p>
                                            </div>
                                            <div class="col-sm-9">
                                                <p class="text-muted mb-0">{{ userProfile.perfilDescripcion }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Almacenes Asociados -->
                            <div class="col-lg-12 ">
                                <div class="card mb-4 mb-lg-0">
                                    <div class="card-body p-0 m-3">
                                        <p class="mb-4 text-center fw-bold">Almacenes Asociados ( {{ almacenes.length
                                            }})
                                        </p>
                                        <base-table-forms :data="almacenes" :headers="headers" :whitPagination="false"
                                            :orderColumn="column" :order="order" :whitOrder="true"
                                            :dataFunction="orderList">
                                            <tr v-for="almacen in almacenes" :key="almacen.Ca110CodAlmacen">
                                                <td class="text-center">{{ almacen.Ca110CodAlmacen }}</td>
                                                <td class="text-center">{{ almacen.Ca110NombreComercial }}</td>
                                                <td class="text-center">{{ almacen.Ca110Direccion }}</td>
                                                <td class="text-center">{{ almacen.rolUsuario.description }}</td>
                                            </tr>
                                        </base-table-forms>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 2FA -->
                    <div v-if="tap == 2">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card mb-12 mb-md-0">
                                    <div class="card-body">
                                        <base-button-forms v-if="isActive2FA == false" classButton="btn-success"
                                            label="Habilitar doble factor de autenticación" type="button"
                                            icon="fa-solid fa-circle-info" :onClick="() => openModal(1)"
                                            :permissionId="0" :isLoading="isLoading2.enableTwoFactor"
                                            :disabled="isLoading2.enableTwoFactor"></base-button-forms>
                                        <base-button-forms v-if="isActive2FA == true" classButton="btn-danger"
                                            label="Deshabilitar doble factor de autenticación" type="button"
                                            icon="fa-solid fa-circle-info" :onClick="() => calldisableTwoFactor()"
                                            :permissionId="0" :isLoading="isLoading2.disableTwoFactor"
                                            :disabled="isLoading2.disableTwoFactor"></base-button-forms>
                                        <base-button-forms v-if="isActive2FA == true" classButton="ms-2 btn-success"
                                            label="Regenerar códigos de recuperación" type="button"
                                            icon="fa-solid fa-circle-info" :onClick="() => callRegenerateRecoveryCode()"
                                            :permissionId="0" :isLoading="isLoading2.regenerateRecoveryCode"
                                            :disabled="isLoading2.regenerateRecoveryCode"></base-button-forms>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </template>
    </the-content-body>
    <!-- Modal 2FA -->
    <widget-modal-boostrap modalId="modalUser" modalTitle="Habilitar Doble factor de autenticación"
        modalClassSize="modal-lg" :showFooter="false" modalStatic="static" @on:modalClose="closeModal">
        <template v-slot:modalBody>
            <div v-show="isActive2FA == false">
                <div class="text-center">
                    <p>Escanea este código QR en tu App de autenticación:</p>
                    <qrcode-vue :value="qr_data" :size="200" />
                     <p>Si no puedes escanearlo, puedes usar la clave secreta: {{ secret_key }}</p>
                </div>
                <div>
                    <p class="mt-3">Luego, ingresa el código generado por la app para completar la configuración.</p>
                    <base-input-group v-model="cod2Fa" title="Código de autenticación" typeInput="code" inputId="code"
                        :errors="errorsFields" icon="fa-solid fa-key"
                        placeholder="Ingrese el código"></base-input-group>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-secondary me-2" @click="closeModal">Cancelar</button>
                        <base-button-forms classButton="btn-primary" label="Verificar y Habilitar" type="button"
                            icon="fa-solid fa-circle-info" :onClick="() => callverifyTwoFactor()" :permissionId="0"
                            :isLoading="isLoading2.verifyTwoFactor"
                            :disabled="isLoading2.verifyTwoFactor"></base-button-forms>
                    </div>
                </div>
            </div>
            <div v-show="isActive2FA">
                <div class="text-center p-4">

                    <h2 class="fw-normal mb-3">Guarde sus códigos de recuperación</h2>

                    <p class="text-muted mb-4" style="margin: 0 auto;">
                        Si pierdes tu teléfono o no puedes acceder a tu aplicación de autenticación, puedes usar un
                        código de seguridad para acceder una sola vez a tu cuenta. Anota estos códigos y guárdalos en un
                        lugar seguro.
                    </p>

                    <div class="d-flex flex-column align-items-center mb-4"
                        style="font-size: 15px; letter-spacing: 2px;">
                        <div v-for="code in codeRecover" :key="code" class="mb-2">
                            {{ code }}
                        </div>
                    </div>

                    <button type="button" class="btn btn-primary px-4 py-2" @click="closeModal">
                        Listo
                    </button>

                </div>


            </div>
        </template>
    </widget-modal-boostrap>
</template>

<script>
import useAuth from '@/modules/auth/composables/useAuth'
import useAuthPrompt from '@/modules/auth/composables/useAuthPrompt'
import useUsers from '@/modules/users/composables/useUsers'
import { orderArray } from '@/helpers/utilities'
import { Modal } from 'bootstrap';

import BaseButtonForms from '@/common/forms/BaseButtonForms.vue';
import BaseTableForms from '@/common/forms/BaseTableForms.vue';
import TheContentBody from '@/modules/dashboard/components/TheContentBody.vue';
import TheContentHeader from '@/modules/dashboard/components/TheContentHeader.vue';
import TheUserAvatar from '@/modules/dashboard/components/TheUserAvatar.vue';
import WidgetLoading from '@/common/widgets/WidgetLoading.vue';
import WidgetModalBoostrap from '@/common/widgets/WidgetModalBoostrap.vue';
import BaseInputGroup from '@/common/forms/BaseInputGroup.vue';
import QrcodeVue from 'qrcode.vue'

import { ref, onMounted } from 'vue'

export default {
    props: {
        userId: {
            type: String,
        }

    },
    components: {
        BaseButtonForms,
        BaseTableForms,
        TheContentBody,
        TheContentHeader,
        TheUserAvatar,
        WidgetLoading,
        WidgetModalBoostrap,
        QrcodeVue,
        BaseInputGroup
    },
    setup(props) {
        const userProfile = ref({})
        const almacenes = ref([])
        const column = ref()
        const order = ref()
        const tap = ref(1)
        const isActive2FA = ref(false)
        const cod2Fa = ref('')
        const codeRecover = ref({})
        const qr_data = ref('')
        const secret_key = ref('')
        const headers = ref(
            [
                { encabezado: 'Código', columna: 'Ca110CodAlmacen' },
                { encabezado: 'Nombre', columna: 'Ca110NombreComercial' },
                { encabezado: 'Dirección', columna: 'Ca110Direccion' },
                { encabezado: 'Rol', columna: null },
            ]
        )
        const { getUserProfile, isLoadingUser, modals } = useUsers()
        const { userDataLoggedIn,
            enableTwoFactor,
            disableTwoFactor,
            verifyTwoFactor,
            isLoading2,
            errorsFields,
            regenerateRecoveryCode } = useAuth()
        const { requestAuthorization } = useAuthPrompt()
        onMounted(() => {
            modals.modalUser = new Modal('#modalUser', {})
        })
        const callGetUserProfile = async (userId) => {
            const { response, data } = await getUserProfile(userId);
            if (response) {
                userProfile.value = data.user
                isActive2FA.value = data.user.two_factor_enabled == 1 ? true : false
                almacenes.value = data.almacenes
            }
        }

        callGetUserProfile(props.userId ? props.userId : userDataLoggedIn.value.id)

        const openModal = async () => {
            const { response, data } = await enableTwoFactor();
            qr_data.value = data.qr_url
            secret_key.value = data.secret
            modals.modalUser.show()
        }
        const closeModal = () => {
            cod2Fa.value = ''
            modals.modalUser.hide()
            codeRecover.value = []
        }

        const callverifyTwoFactor = async () => {
            const { response, data } = await verifyTwoFactor(cod2Fa.value);
            if (response) {
                isActive2FA.value = true
                codeRecover.value = data.two_factor_recovery_codes

            }
        }

        const calldisableTwoFactor = async () => {
            const autorizado = await requestAuthorization('password')


            if (!autorizado) return
            const { response } = await disableTwoFactor(autorizado);
            if (response) {
                isActive2FA.value = false
            }
        }

        const callRegenerateRecoveryCode = async () => {
            const autorizado = await requestAuthorization('otp')
            if (!autorizado) return
            const { response, data } = await regenerateRecoveryCode(autorizado);

            if (response) {
                codeRecover.value = data.two_factor_recovery_codes
                openModal();
            }
        }



        const orderList = (page, col) => {
            if (col) {
                column.value = col
                order.value = order.value == 'asc' ? 'desc' : 'asc'
            }
            almacenes.value = orderArray(almacenes.value, column.value, order.value)
        }





        return {
            userProfile,
            almacenes,
            headers,
            isLoadingUser,
            column,
            order,
            orderList,
            tap,
            isActive2FA,
            openModal,
            closeModal,
            callverifyTwoFactor,
            isLoading2,
            qr_data,
            secret_key,
            cod2Fa,
            errorsFields,
            calldisableTwoFactor,
            callRegenerateRecoveryCode,
            codeRecover

        }

    }

}
</script>

<style scoped>
.scroll {
    overflow-y: scroll;
    max-height: 200px;
}
</style>